export function TermsPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
      <h1 className="mb-6 text-3xl font-bold tracking-tight">Terms of Service</h1>
      <div className="max-w-none space-y-4 text-muted-foreground leading-relaxed">
        <p className="mb-4">
          These Terms of Service govern your use of the WingCaster platform. By accessing or using the platform, you agree to be bound by these terms.
        </p>
        <h2 className="mb-2 mt-6 text-lg font-semibold text-foreground">1. Platform Use</h2>
        <p className="mb-4">
          WingCaster provides a marketplace for property listings, agent profiles, and real-estate related services. You may use the platform only for lawful purposes and in accordance with these terms.
        </p>
        <h2 className="mb-2 mt-6 text-lg font-semibold text-foreground">2. Agent Accounts</h2>
        <p className="mb-4">
          Agents must provide accurate license and contact information. You are responsible for all activity that occurs under your account. Listings must be truthful and comply with applicable real-estate regulations.
        </p>
        <h2 className="mb-2 mt-6 text-lg font-semibold text-foreground">3. Content and Listings</h2>
        <p className="mb-4">
          You retain ownership of the content you post. By posting, you grant WingCaster a license to display and distribute your content on the platform and connected channels. Misleading, fraudulent, or infringing content is prohibited.
        </p>
        <h2 className="mb-2 mt-6 text-lg font-semibold text-foreground">4. Limitation of Liability</h2>
        <p className="mb-4">
          WingCaster is not a party to transactions between users and agents. We do not guarantee the accuracy of listings or the performance of agents. Use the platform at your own risk.
        </p>
        <h2 className="mb-2 mt-6 text-lg font-semibold text-foreground">5. Changes to Terms</h2>
        <p>
          We may update these terms from time to time. Continued use of the platform after changes constitutes acceptance of the revised terms.
        </p>
      </div>
    </div>
  )
}
